// 9fbef606107a605d69c0edbcd8029e5d
import { getIconPath } from '@tcp/core/src/utils';
import { FAV_ICON_NAME_MAP } from '../../plpTileConstants';

const getFavUrl = (isFavorite, brand) => {
  const favKey = isFavorite ? 'solid' : 'outline';
  return getIconPath(FAV_ICON_NAME_MAP[`${brand}-${favKey}`]);
};
const getFavItem = (productId, wishListArray) => {
  return wishListArray.find((rcd) => rcd.productPartNo === productId);
};
const formWishListObj = (wishList, favoritedItem) => {
  const { id, displayName } = wishList || {};
  return {
    id,
    displayName,
    ...favoritedItem,
  };
};

export const currencyConversion = (price, currencySymbol, currencyAttributes) => {
  const { exchangevalue = 1, merchantMargin = 1, roundMethod } = currencyAttributes || {};
  const priceWithOutRounding = price * exchangevalue * merchantMargin;
  const roundedPrice =
    parseInt(roundMethod, 10) >= 0
      ? parseFloat(priceWithOutRounding.toFixed(roundMethod))
      : priceWithOutRounding;
  return `${currencySymbol}${(roundedPrice || 0).toFixed(2)}`;
};

export const getPriceData = (priceProps = {}) => {
  const {
    minListPrice = 0,
    minOfferPrice = 0,
    lowOfferPrice = 0,
    highOfferPrice = 0,
    lowListPrice = 0,
    highListPrice = 0,
    merchantTag = '',
    currencySymbol = '$',
    currencyAttributes = {},
  } = priceProps;
  const isValidOfferPrice = lowOfferPrice && highOfferPrice;
  const isShowOfferPriceRange = isValidOfferPrice && lowOfferPrice !== highOfferPrice;
  const isShowListPriceRange = !lowOfferPrice && highListPrice && lowListPrice !== highListPrice;
  const isShowListPrice =
    highListPrice &&
    lowListPrice !== highListPrice &&
    (lowOfferPrice !== lowListPrice || highOfferPrice !== highListPrice);
  return {
    offerPrice: currencyConversion(minOfferPrice, currencySymbol, currencyAttributes),
    listPrice: currencyConversion(minListPrice, currencySymbol, currencyAttributes),
    lowestOfferPrice: currencyConversion(lowOfferPrice, currencySymbol, currencyAttributes),
    highestOfferPrice: currencyConversion(highOfferPrice, currencySymbol, currencyAttributes),
    lowestListPrice: currencyConversion(lowListPrice, currencySymbol, currencyAttributes),
    highestListPrice: currencyConversion(highListPrice, currencySymbol, currencyAttributes),
    merchantTag,
    isShowListPrice,
    isShowOfferPriceRange,
    isShowListPriceRange,
  };
};

export const getWishListItems = (wishList) => {
  const products = wishList?.items || [];
  return products.map((prod) => {
    return {
      productPartNo: prod.productInfo?.generalProductId,
      itemId: prod.itemInfo?.itemId,
    };
  });
};

export const getWishListData = ({ productPartNo, wishListData, primaryBrand }) => {
  if (wishListData && wishListData.wishlistObj) {
    const { id, displayName } = wishListData;
    const favoritedItem = wishListData.wishlistObj[productPartNo];
    const isFavorite = !!favoritedItem;
    return {
      favIconUrl: getFavUrl(isFavorite, primaryBrand),
      isFavorite,
      wishList: { id, displayName, ...favoritedItem },
    };
  }
  const wishListItems = getWishListItems(wishListData);
  const favoritedItem = getFavItem(productPartNo, wishListItems);
  const isFavorite = !!favoritedItem;
  return {
    favIconUrl: getFavUrl(isFavorite, primaryBrand),
    isFavorite,
    wishList: formWishListObj(wishListData, favoritedItem),
  };
};

export const getOfferPrice = (
  isShowOfferPriceRange,
  isShowListPriceRange,
  lowestOfferPrice,
  highestOfferPrice,
  lowestListPrice,
  highestListPrice,
  lowOfferPrice
) => {
  if (isShowOfferPriceRange) {
    return `${lowestOfferPrice} - ${highestOfferPrice}`;
  }
  if (lowOfferPrice) {
    return lowestOfferPrice;
  }
  if (isShowListPriceRange) {
    return `${lowestListPrice} - ${highestListPrice}`;
  }
  return lowestListPrice || highestListPrice;
};
